import { render, staticRenderFns } from "./SpeakingUtility.vue?vue&type=template&id=1b1d6c54&scoped=true&"
import script from "./SpeakingUtility.vue?vue&type=script&lang=ts&"
export * from "./SpeakingUtility.vue?vue&type=script&lang=ts&"
import style0 from "./SpeakingUtility.vue?vue&type=style&index=0&id=1b1d6c54&prod&lang=css&"
import style1 from "./SpeakingUtility.vue?vue&type=style&index=1&id=1b1d6c54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d6c54",
  null
  
)

export default component.exports